import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import {
  FileInput,
  FormDataConsumer,
  required,
  SelectInput,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import {
  ACCEPTED_FILES_ADVICE,
  CarrierTypes,
  MAX_FILES,
  RA_REQUIRED,
} from "../../../../utils/constants";
import { handleFileChange } from "../../../../utils/fileUtils";
import { AttachFileIcon } from "../../../../components/common/iconography";
import { AccountDropDown } from "../../../../components/common/AccountDropDown";
import { FileField } from "../../../../components/common/FileField";
import { handleCommodityChange } from "../InboundUtils";

const useStyles = makeStyles((theme) => ({
  fileInput: {
    marginTop: -theme.spacing(0),
  },
}));

const validateRequired = required();
const validateRequiredFiles = (value) =>
  Array.isArray(value) && value.length > 0 ? undefined : RA_REQUIRED;

export const AdviceCreateForm = ({
  area,
  account,
  isBrokeredAccount,
  loading,
  setAreas,
  setYardCommodity,
  handleAccountChange,
  handleCarrierTypeChange,
  handlePoNumberBlur,
  getAccountHelperText,
  onAccountsLoaded,
}) => {
  const classes = useStyles();
  const form = useForm();
  const notify = useNotify();
  const yardCommodities =
    window.appUser?.reloadYard?.activeYardCommodities?.items ?? [];
  const isBrokered = isBrokeredAccount(account);

  const loadTypeInput = (formData) => (
    <SelectInput
      source="reloadYardCommodityId"
      label="Load Type"
      variant="outlined"
      fullWidth
      choices={yardCommodities}
      optionText={(choice) => `${choice.commodity.name} - ${choice.units}`}
      optionValue="id"
      validate={validateRequired}
      disabled={formData.inventories?.items?.length > 0}
      helperText={false}
      onChange={(event) =>
        handleCommodityChange(event, form, setYardCommodity, area, setAreas)
      }
    />
  );

  return (
    <FormDataConsumer>
      {({ formData }) => (
        <Grid container direction="row" spacing={3}>
          <Grid item container direction="column" spacing={0} lg={8}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={6}>
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  validate={validateRequired}
                  allowEmpty={false}
                  onAccountChange={(value) =>
                    handleAccountChange(value, formData)
                  }
                  onAccountsLoaded={onAccountsLoaded}
                  loading={loading}
                  helperText={getAccountHelperText()}
                  onBlur={handlePoNumberBlur}
                />
              </Grid>
              {isBrokered && (
                <Grid item xs={12} md={6}>
                  <AccountDropDown
                    source="billToAccountId"
                    label="Billing Account"
                    allowEmpty={false}
                    disabled={true}
                    loading={loading}
                    helperText={false}
                  />
                </Grid>
              )}
              {!isBrokered && (
                <Grid item xs={12} md={6}>
                  {loadTypeInput(formData)}
                </Grid>
              )}
            </Grid>
            <Grid container direction="row" spacing={1}>
              {isBrokered && (
                <Grid item xs={12} md={6}>
                  {loadTypeInput(formData)}
                </Grid>
              )}
              <Grid item xs={12} md={6}>
                <SelectInput
                  source="carrierType"
                  label="Carrier Type"
                  variant="outlined"
                  fullWidth
                  choices={CarrierTypes}
                  validate={validateRequired}
                  onChange={handleCarrierTypeChange}
                  helperText={false}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container direction="row" spacing={0} xs={false} md={4}>
            <Grid item xs={12} id="attachments-advice-input">
              <FileInput
                source="attachments"
                label="Inbound Advice Attachments"
                variant="outlined"
                fullWidth
                className={classes.fileInput}
                validate={validateRequiredFiles}
                helperText="Accepted files: PNG, JPEG, PDF, or TIFF."
                placeholder={
                  <p>
                    <AttachFileIcon fontSize="large" /> <br /> Drop files to
                    upload, or click to select.
                  </p>
                }
                accept={ACCEPTED_FILES_ADVICE}
                multiple
                maxFiles={MAX_FILES}
                options={{ maxFiles: MAX_FILES }}
                onChange={(value) =>
                  handleFileChange("attachments", value, form, notify)
                }
              >
                <FileField source="src" title="title" target="_blank" />
              </FileInput>
            </Grid>
          </Grid>
        </Grid>
      )}
    </FormDataConsumer>
  );
};
